/*
Ashraf 01/12/2023 2699710829 client audit search results table
Ashraf 01/12/2023 2699710829 fixed error handling after submit
Ashraf 01/12/2023 2699710829 filtered active options for audit list.
Ashraf 01/13/2023 2699710829 Added download functionality.
suresh peddavoora 02/21/2023 2699710829 new UI changes for texfields and tables alignments

Ravi 02//23/2023 2699710829 Added popup in download configuration button.
Dilip 02/28/2023 2699710829 Fixed Sorting issue
Ravi 03/01/2023 2699710829 Added loader and download toast message for preview File
Ravi 03/17/2023 2699710829 changed Add Audit Client List popup title based on condition
Raghu 03/04/2023 2699710829 added plus icon
Akhila 04/19/2023 2699710829  modified client code dropDownData data
Sohel 05/30/2023 2699710829 Fixed Search and Download Configuration Disabled issue
Ravi 05/31/2023 2699710829 changed delete popup message
Ravi 06/30/2023 2699710829 fixed search button functionality
*/

import {Button, Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useEffect, useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from '../../../../../util/Rest';
import {resetMessage} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import OverrideRule from '../../../../../components/OverrideRule';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../util/UsageMessage';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DialogBox from '../../../../../components/DialogBox';
import {downloadButton} from '../../../../../util/Content';
import AddClientAuditForm from './AddClientAudit';
import {
  fetchClientAuditListData,
  getClientAuditCodeData,
  fetchSuccess,
  resetGlobalFieldList,
  resetStatusAndMessage,
  printClientAuditList,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/GlobalField/ClientAuditList';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import AddIcon from '@material-ui/icons/AddOutlined';
const FieldListSearchTable = ({
  searchData,
  setTabValue,
  submit,
  setSubmit,
  setFieldListRowData,
  setUsage,
  setDeleteUsage,
  usage,
  isDelete,
  setIsDelete,
  userMetrixDelete,
  setUsageState,
  usageState,
  setRowSelected,
  setUserMetrixDelete,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  setFieldList,
  fieldList,
  isReportLoader,
  AuditFieldList,
  deleteSql,
  auditSearchData,
  field,
}) => {
  const tableRef = createRef();
  const queryRef = useRef(null);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [checked, setChecked] = useState();
  const [rows, setRows] = useState(defaultRows);
  const [clientAuditPopup, setClientAuditPopup] = useState('');

  const [deleteData, setDeleteData] = useState({});
  console.log(deleteData, 'asasasd');
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [isNote, setIsNote] = useState(false);
  const {searchRecordFormatFieldData} = useSelector(({addRecordFormat}) => addRecordFormat);
  const {ClientAuditListPrintStatus, successMsg, errorMsg, isLoading, fieldListDataUsage} =
    useSelector(({addFieldList}) => addFieldList);
  const {basicInfoData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {filterRuleGroupData} = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  // const { fieldlListData } = useSelector(({ reportMaster }) => reportMaster);
  const printusage = useSelector(({printusage}) => printusage);
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Client Audit Field List']?.['CAFL'];
  // const disableDelete = roleData?.window?.["Global Fields"]?.["GF"]?.delete;
  // const disableDelete = roleData?.window?.["Field List"]?.["FL"]?.delete;
  const [code, setCode] = useState(fieldList);
  const [isEdit, setIsEdit] = useState(false);
  const {
    successMsg: auditSuccessMsg,
    auditFieldListStatus,
    auditListData,
    isLoading: auditLookupLoading,
    errorMsg: clientAuditError,
    configurationUrl,
    dockey,
  } = useSelector(({auditFieldList}) => auditFieldList);
  const {clientCodeData, isLoading: clientLookupLoading} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  console.log(clientCodeData, 'clientCodeData)');
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  console.log(clientCodeDropdownData, 'clientCodeDropdownData');
  const maxSelections = 1;
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const handleSelectionProps = (rowData) => {
    return {
      disabled: !!(checked && checked.length >= maxSelections && !rowData.tableData.checked),
    };
  };
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);

  useEffect(() => {
    if (tableRef?.current && !fieldList) {
      tableRef.current.onQueryChange();
      setChecked([]);
    }
  }, [fieldList]);

  useEffect(() => {
    if (tableRef?.current && code) {
      tableRef.current.onQueryChange();
    }
  }, [code]);
  useEffect(() => {
    if (fieldList) {
      setStatus(true);
    }
  }, [fieldList]);
  // if table data print successfully or error message then reset message after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  // global Field Print successfully then reset Data after 3sec(2700799562)
  useEffect(() => {
    if (auditFieldListStatus && auditFieldListStatus === 200) {
      setClientAuditPopup(false);
      tableRef?.current?.onQueryChange();
      setIsEdit(false);
      dispatch(getClientAuditCodeData());
      setTimeout(() => {
        dispatch(resetStatusAndMessage());
      }, 3000);
    }
  }, [auditFieldListStatus]);

  // delete data reset error or sucess toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    // dispatch(fetchGlobalFieldListUsage(rowData.fieldListCode));
    setIsDelete(true);
    // setDeleteUsage(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };

  useEffect(() => {
    dispatch(getClientAuditCodeData());
  }, []);

  // status is changed Update Table Data(2700799562)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (ClientAuditListPrintStatus && ClientAuditListPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [ClientAuditListPrintStatus]);

  // delete Global Field List(2700799562)
  const handleSubmit = () => {
    setStatus(true);
    httpPaginationDelete(`debtor-audit/delete/clientaudit/${deleteData?.clientNumber}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setStatus(false);
          dispatch(fetchSuccess(response));
          handleCloseDialog();
          tableRef?.current?.onQueryChange();
          dispatch(getClientAuditCodeData());
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setStatus(false);
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // checking when delete there is usage or not(2700799562)
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldListRowData(deleteData);
      setUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);

      // setTabValue(2);
    } else {
      handleSubmit();
    }
  };

  const getObject = (option, options) => {
    let label = '';
    options &&
      options?.length > 0 &&
      options?.forEach((item) => {
        if (item?.fieldListCode === option && item?.isActive === 'Y') {
          label = item?.fieldListCode + ' - ' + item?.fieldListDesc;
        } else if (item?.clientNumber === option) {
          label = item?.clientName;
        } else if (item?.clientCode === option) {
          label = item?.clientCode;
        }
      });
    return label;
  };

  const columns = [
    {
      title: 'Client Code',
      field: 'clientNumber',
      render: (rowData) => {
        return rowData?.clientNumber ?
          getObject(rowData?.clientNumber, clientCodeDropdownData) :
          '';
      },
    },
    {
      title: 'Audit List',
      field: 'auditfieldsList',
      render: (rowData) => {
        return rowData?.auditfieldsList ? getObject(rowData?.auditfieldsList, auditListData) : '';
      },
    },
    // {
    //   title: `${AuditFieldList ? "Audit" : ""} Field List Code`,
    //   field: "fieldListCode",
    //   render: (rowData) => (
    //     <span
    //       role="button"
    //       className={classes1.link}
    //       onClick={() => {
    //         // if(rowData?.fieldListCode){
    //         //dispatch(fetchFieldListData(rowData?.fieldListCode));
    //         dispatch(fetchGlobalFieldListData(rowData?.fieldListCode), AuditFieldList);
    //         setRowSelected(rowData?.fieldListCode);
    //         if (!StepperFieldList) {
    //           setTabValue(1);
    //           setGlobalFieldRow(true);
    //         } else {
    //           setShowSearch(true);
    //         }
    //         // }
    //       }}
    //     >
    //       {rowData?.fieldListCode}
    //     </span>
    //   ),
    // },
    // {
    //   title: `${AuditFieldList ? "Audit" : ""} Field List Description`,
    //   field: "fieldListDesc",
    // },
    // {
    //   title: "Created By",
    //   field: "createdBy",
    // },
    // {
    //   title: "Created Date",
    //   field: "createdDate",
    //   render: (rowData) => {
    //     return rowData?.createdDate ? moment(rowData?.createdDate).format("MM/DD/YYYY") : "";
    //   },
    // },
  ];

  useEffect(() => {
    if (fieldList) {
      setCode(fieldList);
    }
  }, [fieldList]);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);
  useEffect(() => {
    if (!StepperFieldList) {
      dispatch(resetGlobalFieldList());
    }
  }, []);
  const handleNotesDialog = () => {
    setIsNote(false);
  };

  const SearchSessionFieldList = JSON.parse(sessionStorage.getItem('ClientFieldList'));

  if (SearchSessionFieldList && !submit && !StepperFieldList) {
    searchData = SearchSessionFieldList;
  }

  const handleClientAuditClose = () => {
    setClientAuditPopup(false);
    setIsEdit(false);
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  return (
    <>
      <DialogBox
        open={isNote}
        dialogClose={handleNotesDialog}
        title={`${AuditFieldList ? 'Audit' : ''} Field List System Notes`}
        maxWidth="lg"
        hideFooter={true}
      >
        {/* <GlobalFieldListSystemNotes filedListCode={notesFieldListCode} /> */}
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Client Audit field list'}
      />
      {isLoading || (
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleCloseDialog}
          title={`Delete ${AuditFieldList ? 'Audit' : ''} Client Audit Field List `}
          value={
            userMetrixDelete ? (
              <UsageMessage
                value={`${deleteData?.fieldListCode} ${AuditFieldList ? 'Audit' : ''} Field List`}
              />
            ) : (
              `Are you sure you want to delete the ${getObject(
                deleteData?.clientNumber,
                clientCodeData,
              )} ${AuditFieldList ? 'Audit' : ''} Client Audit Field List ?`
            )
          }
          handleSubmit={handleDeleteUsage}
          buttonCondition={userMetrixDelete}
        />
      )}

      <OverrideRule
        dialogTitle={`${AuditFieldList ? 'Audit' : ''} Field List Usage`}
        dialogOpen={usage}
        dialogClose={() => setUsage((state) => !state)}
        title={`This ${
          AuditFieldList ? 'Audit' : ''
        } Field List has been used in the following places.`}
        data={fieldListDataUsage?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={clientAuditPopup}
        dialogClose={() => handleClientAuditClose()}
        title={isEdit ? 'Edit Client Audit Field List' : 'Add Client Audit Field List'}
        maxWidth="md"
      >
        <AddClientAuditForm setIsEdit={setIsEdit} isEdit={isEdit} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table  new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading || auditLookupLoading || clientLookupLoading}
            onSelectionChange={(rows, unselected) => {
              if (
                deleteSql &&
                unselected.tableData.checked &&
                unselected.fieldListCode !== filterRuleGroupData.fieldListCode &&
                filterRuleGroupData.isDraft === 'N'
              ) {
                deleteSql.current = [];
                filterRuleGroupData.filterSQLRuleResponse.forEach((el) =>
                  deleteSql.current.push(el.id),
                );
              }
              if (
                Object.keys(basicInfoData)?.length > 0 &&
                deleteSql &&
                unselected.tableData.checked &&
                unselected.fieldListCode !== basicInfoData.fieldListCode &&
                basicInfoData.isDraft === 'N'
              ) {
                deleteSql.current = [];
                basicInfoData?.addRule?.forEach((el) => deleteSql.current.push(el?.ruleId));
              }
              setChecked(rows);
              setFieldListCode(rows[0]?.fieldListCode);
              setFieldList(rows[0]?.fieldListCode);
              !rows?.length && dispatch(resetGlobalFieldList());
            }}
            // isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `debtor-audit/search/clientnumberauditfieldlist`;
                setFieldListCode && setFieldListCode(searchData?.fieldListCode);
                const bodyObj = {
                  clientNumber: searchData?.clientCode?.clientNumber ?
                    searchData?.clientCode?.clientNumber :
                    '',
                  auditfieldsList: searchData?.auditfieldsList ? searchData.auditfieldsList : '',
                  // tabType: AuditFieldList ? "AuditField" : "",
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  // createdBy: data?.createdBy?.userName ? data?.createdBy?.userName : "",
                  // createdDate: data?.createdDate
                  //   ? moment(data?.createdDate).format("MM/DD/YYYY")
                  //   : "",
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: query?.search ? query?.search : '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (
                  Object.keys(searchRecordFormatFieldData).length > 0 &&
                  searchRecordFormatFieldData.status
                ) {
                  bodyObj['frameWorkType'] = 'Enable';
                }

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response?.resultObjects;
                        const newData =
                          data?.length > 0 ?
                            data?.map((i) => {
                              if (i?.fieldListCode === code?.toUpperCase()) {
                                return {
                                  ...i,
                                  tableData: {checked: true},
                                };
                              } else {
                                return {
                                  ...i,
                                };
                              }
                            }) :
                            [];
                        resolve({
                          data: fieldList ? newData : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      disabled={!disable?.add}
                      startIcon={<AddIcon />}
                    >
                      Add Client Audit Field List
                    </Button>
                  </>
                ),
                disabled: !disable?.add,
                isFreeAction: true,
                onClick: (event) => {
                  setClientAuditPopup(true);
                  // if (StepperFieldList) {
                  //   dispatch(resetMessage());
                  //   setShowSearch(true);
                  // } else {
                  //   setTabValue(1);
                  // }
                },
              },
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                disabled: !disable?.edit,
                hidden: StepperFieldList,
                onClick: (event, rowData) => {
                  // dispatch(fetchFieldListData(rowData?.fieldListCode));
                  dispatch(fetchClientAuditListData(rowData?.clientNumber));
                  // setTabValue(1);
                  setClientAuditPopup(true);
                  setIsEdit(true);
                },
              },
              {
                icon: () => (
                  <>
                    <DeleteOutlineOutlinedIcon />
                  </>
                ),
                tooltip: 'Delete',
                hidden: StepperFieldList,
                disabled: !disable?.delete,
                onClick: (event, rowData) => {
                  handleDelete(rowData);
                },
              },
              // {
              //   icon: () => (
              //     <>
              //       <FileCopyOutlinedIcon className={classes.copyButtonroot} />
              //     </>
              //   ),
              //   tooltip: "Copy",
              //   position: "row",
              //   disabled: !disable?.add,
              //   onClick: (event, rowData) => {
              //     setIsCopyData(true);
              //     //dispatch(fetchFieldListData(rowData?.fieldListCode));
              //     dispatch(fetchGlobalFieldListData(rowData?.fieldListCode));
              //     if (!StepperFieldList) {
              //       setTabValue(1);
              //     } else {
              //       setShowSearch(true);
              //       setFieldList("");
              //     }
              //   },
              // },
              // {
              //   icon: () => <DataUsageIcon className={classes.copyButtonroot} />,

              //   tooltip: "Usage",
              //   hidden: StepperFieldList,
              //   onClick: (event, rowData) => {
              //     setDeleteUsage(false);
              //     dispatch(fetchGlobalFieldListUsage(rowData?.fieldListCode));
              //     setFieldListRowData(rowData);
              //   },
              // },
              // {
              //   icon: () => (
              //     <>
              //       <DeleteOutlineOutlinedIcon />
              //     </>
              //   ),
              //   tooltip: "Delete",
              //   hidden: StepperFieldList,
              //   //disabled: !disableDelete,
              //   disabled: !disable?.delete,
              //   onClick: (event, rowData) => {
              //     handleDelete(rowData);
              //   },
              // },
              // {
              //   icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
              //   tooltip: `${AuditFieldList ? "Audit" : ""} Field List Notes`,
              //   hidden: StepperFieldList,
              //   onClick: (event, rowData) => {
              //     setIsNote(true);
              //     setNotesFieldListCode(rowData?.fieldListCode);
              //   },
              // },
            ]}
            options={{
              search: false,
              pageSize: rows,
              selection: StepperFieldList,
              toolbarButtonAlignment: 'left',
              selectionProps: handleSelectionProps,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                // Added Download Configuration Buttons in Table Pagination (2700799562)
                <div className="global-field-table-footer ">
                  {
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(queryRef.current?.totalCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            printClientAuditList({
                              clientNumber: searchData?.clientCode?.clientCode ?
                                searchData?.clientCode?.clientCode :
                                '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              orderDirection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                            }),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  }
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
        {isLoadingPrint && <PageLoader />}
        {(errorMsg || deleteErrorMsg || printusage?.errorMsg || clientAuditError) && (
          <ErrorSnackbar
            errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg || clientAuditError}
          />
        )}
        {(successMsg || printusage?.successMsg || tstmsg || auditSuccessMsg) && (
          <SuccessSnackbar
            successMsg={successMsg || printusage?.successMsg || tstmsg || auditSuccessMsg}
          />
        )}
      </Grid>
    </>
  );
};

export default FieldListSearchTable;
